import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * App-boot loading screen. Shows the Banyan browser-tab mark (a grey #666 tile
 * with a serif "B") whose letter fills from bottom to top — grey to white — on a
 * loop while auth resolves. Replaces the old "Thinking for N seconds" bouncing
 * dots. Rendered full-screen by HomeRoute / MainLayout while `isLoading`.
 *
 * The fill is an indeterminate loop (auth is a single async check with no
 * granular progress), so it reads as a steady "loading" pulse rather than a
 * progress bar. Honors prefers-reduced-motion (renders the filled/white B).
 */
const LoadingAnimation = () => {
  const { darkMode } = useTheme();
  return (
    <div
      role="status"
      aria-label="Loading"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: darkMode ? '#0A0A0A' : '#FFFFFF',
      }}
    >
      <div className="banyan-b-tile">
        <span className="banyan-b-base">B</span>
        <span className="banyan-b-fill" aria-hidden="true">B</span>
      </div>
    </div>
  );
};

export default LoadingAnimation;
